<div class="top-bar">
  <div class="visibility">
    <visibility-toggle
      *ngIf="
        selectedDataConfig && selectedDataConfig['standard_aggregate_group_id']
      "
      class="visibility-slide-toggle"
      [visible]="selectedDataConfig?.visible"
      (toggledEvent)="visibilityToggled($event)"
    ></visibility-toggle>
    <img
      [src]="'../../assets/images/help.png'"
      class="question-icon"
      [matTooltipPosition]="'below'"
      [matTooltip]="tooltipText"
      *ngIf="
        selectedDataConfig && selectedDataConfig['standard_aggregate_group_id']
      "
    />
  </div>
  <div class="title-div-with-button">
    <div class="title-with-icon">
      <h1 class="main-title">Configure {{ name }}</h1>
      <a
        [href]="helpUrl"
        target="_blank"
        class="need-help-link"
        title="Open help page in new tab"
        >Need help?</a
      >
    </div>
    <button
      mat-raised-button
      (click)="reportIssue()"
      class="report-issue-btn green-btn"
      *ngIf="!isStarterUser"
    >
      REPORT ISSUE
    </button>
  </div>
</div>
